<template>
  <div class="content-wrapper">
    <!-- <layout></layout> -->
    <crumbs :trails="trails"></crumbs>
    <div class="bill-detail">
      <div class="filter-search">
        <el-form :inline="true" :rules="rules" :model="searchData" ref="searchForm">
          <el-form-item label="媒体商ID：" prop="UserId">
            <el-input onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode || event.which))) || event.which === 8" maxlength="9" type="text" size="small" v-model.number="searchData.UserId" clearable placeholder="请输入媒体商ID"></el-input>
          </el-form-item>
          <el-form-item label="公司名称：">
            <el-input size="small" v-model="searchData.CompanyName" clearable placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-form-item label="媒介：">
            <el-select size="small" v-model="searchData.SourcemanId" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <template v-for="item in SourceUserList">
                <el-option :label="item.UserName" :value="item.UserId" :key="item.UserId"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="媒体运营：">
            <el-select size="small" v-model="searchData.SourceOperatorId" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <template v-for="item in SourceOperatorUserList">
                <el-option :label="item.UserName" :value="item.UserId" :key="item.UserId"></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="添加日期：">
            <el-date-picker size="small" v-model="searchData.time" type="daterange" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getPrepaidMediaDetails">查询</el-button>
            <a class="export-button" :disabled="!ExportPrepaidMediaDetailData" :href="exportUrl" target="_blank">导出数据</a>
            <el-button type="primary" size="small" :disabled="!AddPrepaidMediaAmount" @click="addadvace">添加预付金额</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 数据列表 -->
      <div class="data-list">

        <el-table :data="tableData" stripe header-row-class-name="table-header-style" style="width: 100%">
          <el-table-column align="center" fixed="left" label="操作" width="110">
            <template slot-scope="scope">
              <el-button @click="changeBillInfo(scope.row)" type="text" size="small" :disabled="scope.row.status === 3">发票明细</el-button>
            </template>
          </el-table-column>
          <el-table-column align="center" :formatter="formatDater" prop="AddDate" label="添加日期" min-width="110">
          </el-table-column>
          <el-table-column align="center" prop="OrderNumber" label="订单号" min-width="250">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="OperatorName" label="操作员" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="UserId" label="媒体商ID" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="CompanyName" label="公司名称" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="SourceOperator" label="媒体运营" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="MediaName" label="媒介" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="ContractCompany" label="合同公司" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="BeforeBalance" label="调整前金额" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="PretaxAmount" label="预付金额" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="AfterBalance" label="调整后金额" min-width="130">
          </el-table-column>
          <el-table-column align="center" show-overflow-tooltip prop="InvoiceAmount" label="累计发票金额" min-width="130">
          </el-table-column>
          <el-table-column align="center" label="备注" min-width="130">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="scope.row.Remark" placement="top">
                <el-button @click="changeRemark(scope.row)" icon="el-icon-edit-outline" type="text" size="small" style="overflow:hidden; white-space:nowrap; text-overflow:ellipsis">
                  {{scope.row.Remark}}
                </el-button>
                <el-button>上左</el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
        background
        layout="prev, pager, next"
        :total="dataSize"
        :current-page="currentPage"
        @current-change="pageChange"
        >
        </el-pagination> -->
      </div>
    </div>
    <!-- 弹层设置 -->
    <addAdvancedDialog :isShowdialog="isShowDiaLog" @close='closeDialog' :dialogPragram="dialogPragram"></addAdvancedDialog>
    <changeBillRemarkDialog :isShowdialog="isShowRemarkDialog" @close='closeRemarkDialog' :dialogPragram="remarkData"></changeBillRemarkDialog>
  </div>
</template>

<script type="text/ecmascript-6">
// 面包屑
import crumbs from "../public/crumbs/newCrumbs";
import addAdvancedDialog from "../public/import-preview/add-advanced-dialog";
import changeBillRemarkDialog from "../public/import-preview/change-billRemark-dialog";
import { formatDateAll } from "common/js/common";
import { ZStream } from "common/js/jszip";
import { XLSX } from "common/js/myexcel";
// api
import {
  GetPrepaidMediaDetails,
  getSourceOperatorUserList,
  getSourceUserList,
  AddPrepaidMediaAmount,
  UpdateRemark
} from "api/mediaWithdraw";

export default {
  data() {
    var validateUserId = (rule, value, callback) => {
      if (value != "") {
        if (/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) == false) {
          callback(new Error("请填写数字！"));
        } else if (value > 999999999) {
          callback(new Error("输入不能超过9个字符"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      searchData: {
        UserId: "",
        CompanyName: "",
        SourcemanId: "",
        SourceOperatorId: "",
        time: ""
      },
      rules: {
        UserId: [{ validator: validateUserId, trigger: "change" }]
      },
      trails: [
        {
          trail: "财务管理",
          href: ""
        },
        {
          trail: "财务添加",
          href: "IAD_PrepaidMedia"
        },
        {
          trail: "账单明细",
          href: ""
        }
      ],
      isShowRemarkDialog: false,
      dataSize: 0,
      isShowDiaLog: false,
      dialogPragram: {
        title: "提示",
        data: {},
        callback: null
      },
      tableData: [],
      // currentPage: 1
      SourceOperatorUserList: [],
      SourceUserList: [],
      remarkData: {}
    };
  },
  computed: {
    exportUrl() {
      var filterData = {
        pageIndex: this.currentPage,
        SourceOperatorId: this.searchData.SourceOperatorId,
        SourcemanId: this.searchData.SourcemanId,
        UserId: this.searchData.UserId,
        CompanyName: this.searchData.CompanyName,
        BeginDate: this.searchData.time ? this.searchData.time[0] : "",
        EndDate: this.searchData.time ? this.searchData.time[1] : ""
      };
      var url = `/IAD_PrepaidMedia/ExportPrepaidMediaDetailData?_t=${new Date().getTime()}`;
      for (var key in filterData) {
        url += `&${key}=${filterData[key] ? filterData[key] : ""}`;
      }
      return url;
    },
    AddPrepaidMediaAmount() {
      if (this.$store.state.authorization.IAD_PrepaidMedia) {
        if (this.$store.state.authorization.IAD_PrepaidMedia.PageFuncs) {
          return this.$store.state.authorization.IAD_PrepaidMedia.PageFuncs
            .AddPrepaidMediaAmount;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    ExportPrepaidMediaDetailData() {
      if (this.$store.state.authorization.IAD_PrepaidMedia) {
        if (this.$store.state.authorization.IAD_PrepaidMedia.PageFuncs) {
          return this.$store.state.authorization.IAD_PrepaidMedia.PageFuncs
            .ExportPrepaidMediaDetailData;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  components: {
    crumbs,
    addAdvancedDialog,
    changeBillRemarkDialog
  },
  methods: {
    // 获取媒体运营数据
    initData() {
      getSourceOperatorUserList().then(res => {
        this.SourceOperatorUserList = Object.assign(
          {},
          this.SourceOperatorUserList,
          res.list
        );
      });
      getSourceUserList().then(res => {
        this.SourceUserList = Object.assign({}, this.SourceUserList, res.list);
      });
    },
    getPrepaidMediaDetails() {
      var filterData = {
        SourceOperatorId: this.searchData.SourceOperatorId,
        SourcemanId: this.searchData.SourcemanId,
        UserId: this.searchData.UserId,
        CompanyName: this.searchData.CompanyName,
        BeginDate: this.searchData.time ? this.searchData.time[0] : "",
        EndDate: this.searchData.time ? this.searchData.time[1] : ""
      };
      this.$nextTick(() => {
        this.$refs["searchForm"].validate(valid => {
          if (valid) {
            GetPrepaidMediaDetails(filterData)
              .then(res => {
                if (res.list) {
                  this.tableData = res.list;
                  this.dataSize = res.list.length;
                } else {
                  this.tableData = [];
                  this.dataSize = 0;
                }
              })
              .catch(res => {
                this.tableData = [];
                this.dataSize = 0;
              });
          } else {
            return false;
          }
        });
      });
    },
    closeDialog() {
      this.isShowDiaLog = false;
    },
    addadvace() {
      this.dialogPragram.title = "预付金额添加";
      this.isShowDiaLog = true;
      this.dialogPragram.callback = this.addPrepaidMediaAmount;
    },
    addPrepaidMediaAmount(data) {

      this.$nextTick(() => {
        if (data.PretaxAmount > 0) {
          setTimeout(() => {
            this.$confirm(
              `您当前填写金额为${data.PretaxAmount}, 是否通过?`,
              "预付款确认",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
              }
            )
              .then(() => {
                data.UserId = this.$route.params.id;
                AddPrepaidMediaAmount(data).then(res => {
                  this.isShowDiaLog = false;
                  this.getPrepaidMediaDetails();
                });
              })
              .catch(() => {
              });
          });
        } else {
          data.UserId = this.$route.params.id;
          AddPrepaidMediaAmount(data).then(res => {
            this.isShowDiaLog = false;
            this.getPrepaidMediaDetails();
          });
        }
      });
    },
    changeBillInfo(row) {
      this.$router.push({
        name: "prepaidInvoiceDetails",
        params: { BusinessId: row.BusinessId, UserId: this.$route.params.id }
      });
    },
    // 格式化日期
    formatDater(row, column, cellValue, index) {
      return formatDateAll(cellValue);
    },
    changeRemark(row) {
      this.remarkData = row;
      this.isShowRemarkDialog = true;
      this.remarkData.callback = this.updateRemark;
    },
    closeRemarkDialog() {
      this.isShowRemarkDialog = false;
    },
    updateRemark(params) {
      UpdateRemark(params).then(res => {
        this.isShowRemarkDialog = false;
        this.getPrepaidMediaDetails();
      });
    }
    // 分页切换页码
    // pageChange(currentPage) {
    //   this.currentPage = currentPage;
    //   this.getPrepaidMediaDetails();
    // }
  },
  created() {
    document.title = "账单明细";
    this.initData();
    this.searchData.UserId = this.$route.params.id;
    this.getPrepaidMediaDetails();
  },
  mounted() {},
  beforeRouteLeave(to, from, next) {
    if (to.name === "prepaidInvoiceDetails") {
      if (!from.meta.keepAlive) {
        from.meta.keepAlive = true;
      }
      next();
    } else {
      from.meta.keepAlive = false;
      // to.meta.keepAlive = false;
      this.$destroy();
      next();
    }
  },
  activated() {
    this.getPrepaidMediaDetails();
  }
};
</script>
<style>
.navbar {
  min-height: none;
  max-height: 50px;
}
ul.nav {
  padding: 0 !important;
}
#navbar .sign-in-wrap {
  padding-right: 50px !important;
}
.launchTime .el-date-editor .el-range-separator {
  width: 10% !important;
}
#edui1_iframeholder {
  max-height: 177px !important;
  overflow: auto !important;
}
.money-icon {
  margin-right: 5px !important;
}
.areaWindow .el-dialog {
  width: 940px !important;
  margin-top: 4vh !important;
}
.areaWindow .el-dialog__body {
  padding: 8px 32px 75px !important;
}
.putonArea .region {
  margin-top: 4px !important;
}
.putonArea .region .provinces-group {
  width: 650px !important;
}
.putonArea .region .provinces-group .provinces {
  border: 1px solid transparent;
}
.putonArea .region .provinces-group .provinces .cities-group {
  max-height: 150px !important;
  font-size: 14px !important;
  border: 1px solid #ccc !important;
  border-left: none !important;
}
.putonArea .region .provinces-group .provinces.mouseon .cities-group .cities {
  border-right: none !important;
  border-bottom: none !important;
}
.el-select-dropdown__wrap {
  margin-right: -71px !important;
}
</style>
<style lang="scss">
@import "../../common/scss/color.scss";
.bill-detail {
  .filter-search {
    border: 1px solid #f2f2f2;
    padding: 20px 15px;
    .el-input {
      width: 150px;
    }
    .el-select {
      .el-input {
        width: 110px;
      }
    }
    .el-date-editor {
      width: 250px;
    }
    .el-button {
      min-width: 94px;
    }
    .export-button {
      width: 94px;
      display: inline-block;
      color: #fff;
      background-color: #5798d7;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      border: 1px solid #5798d7;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin: 0 10px;
      padding: 9px 15px;
      font-size: 12px;
      border-radius: 4px;
      &:hover {
        background: #66b1ff;
        border-color: #66b1ff;
        color: #fff;
      }
    }
  }
  .data-type {
    padding: 15px;
    .data-size {
      color: #bbbbbb;
    }
    .el-icon-menu:before {
      font-size: 24px;
      vertical-align: middle;
    }
  }
  .data-list {
    .el-button {
      margin: 0;
      width: 100%;
      font-size: 14px;
    }
    thead {
      tr {
        background-color: #f5f5f5 !important;
        border-bottom: 2px solid #bbb;
        text-align: center;
      }
    }
    .el-pagination {
      text-align: center;
      margin: 30px 0;
    }
  }
  .image-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: #000;
    .close-image-modal {
      display: inline-block;
      width: 20px;
      height: 20px;
      position: absolute;
      top: -5px;
      right: -5px;
      font-size: 28px;
      color: #e5e5e5;
      background-color: #fff;
      line-height: 15px;
      border-radius: 10px;
      cursor: pointer;
    }
    img {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/financial-management/bill-detail.vue